import image from "../../assets/image.jpg";
import cv from "../../assets/JOSUÉ ALEJANDRO MEDINA GUERRERO.pdf";
import "./aboutme.css";

const AboutMe = () => {
   return (
      <div id="aboutme" style={{ scrollMarginTop: "70px" }} className="aboutme my-5">
         <div className="d-flex justify-content-center">
            <div className="card border-0" style={{ maxWidth: "900px" }}>
               <div className="row g-0 justify-content-center">
                  <img src={image} className="col-8 col-sm-5 img-fluid rounded-start" alt="" />
                  <div className="col-8 col-sm-6 bg-dark text-light">
                     <div className="card-body px-4">
                        <div className="card-title display-4 my-3 fw-bold">About me</div>
                        <p className="card-text mb-3">
                           Developer with more than two years building projects implemented with HMTL, CSS,
                           Javascript, Typescript, React, Redux, Node, Express, MongoDB, NextJS, Java, Spring
                           Boot and Security, Python, Django, Mysql, Bootstrap... Always looking for options
                           optimized, creating robust and scalable code. <br />
                           <br /> I always seek to improve my skills and continue to grow professionally in
                           order to make valuable contributions to development. Eager to learn new things. I
                           am a self-taught person, in constant development and learning.
                           <br />
                           <br />
                           <a className="btn btn-success" href={cv} target="_blank" rel="noreferrer">
                              Download CV
                           </a>
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default AboutMe;
